import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const DeleteNestedPagesActionLoader: LoadableType<
	DialogsContainerProps & {
		contentId: string;
		source: string;
		shouldRedirectOnSuccess: boolean;
		focusAfterModalClose?: () => void;
		onSuccess?: () => void;
		contentType?: string;
		shouldShowSmartFolderNestedDelete?: boolean;
	}
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DeleteNestedPagesActionLoader" */ '../src/Delete/DeleteNestedPagesAction.tsx'
			)
		).DeleteNestedPagesAction,
});
